import { action, observable, computed } from 'mobx';
import { StatusCodes } from 'http-status-codes';

import logger from 'logger';
import MyShopService from 'services/MyShopService';
import APIStates from 'enum/APIStates';
import { MY_LIBRARY_FILTERS } from 'enum/helpers';


export class MyShopStore {
  @observable performerVideos = [];
  @observable videosTotalCount = 0;
  @observable allCount = 0;
  @observable allCost = 0;
  @observable performerVideosState = APIStates.INITIAL;
  @observable buyAllState = APIStates.INITIAL;
  @observable playUrl = '';
  @observable videoActionState = APIStates.INITIAL;
  @observable videoPurchased = false;
  @observable allVideosPurchased = false;

  @action reset = () => {
    this.playUrl = '';
    this.videoPurchased = false;
    this.videoActionState = APIStates.INITIAL;
  };

  @action retVideoNum = () => {
    if (location.pathname.length > 0) {
      const tempPathArr = location.pathname.split('/');
      if (tempPathArr.length === 4 && tempPathArr[2] === 'myshop' && !Number.isNaN(parseInt(tempPathArr[3], 10))) {
        return tempPathArr[3];
      }
    }

    return null;
  };

  @action getPerformerVideos = (username, sortBy, limit) => {
    this.performerVideosState = APIStates.PENDING;
    MyShopService.getPerformerVideos(username, sortBy, limit)
      .then((response) => {
        if (sortBy === MY_LIBRARY_FILTERS.DURATION) {
          const { videos } = response;
          this.performerVideos = videos.reverse();
        } else {
          this.performerVideos = response.videos;
        }
        this.videosTotalCount = response.totalCount;
        this.performerVideosState = APIStates.LOADED;
      })
      .catch((err) => {
        logger.error(err);
        if (err.message.includes(StatusCodes.NOT_FOUND)) {
          this.performerVideosState = APIStates.ERROR_404;
        } else {
          this.performerVideosState = APIStates.ERROR;
        }
      });
  };

  @action getBuyAll = (performer) => {
    MyShopService.getBuyAll(performer).then((response) => {
      this.allCount = response.videosCount;
      this.allCost = response.videosCost;
    });
  };

  @action buyAll = (performer) => {
    this.buyAllState = APIStates.PENDING;
    MyShopService.buyAll(performer).then(() => {
      this.buyAllState = APIStates.LOADED;
      this.allCount = 0;
      this.allVideosPurchased = true;
    });
  };

  @action likeVideo = (id) => {
    MyShopService.likeVideo(id).then(() => {
      const video = this.performerVideos.find((video) => video.videoId === id);
      video.likes += 1;
      video.liked = true;
    });
  };

  @action unlikeVideo = (id) => {
    MyShopService.unlikeVideo(id).then(() => {
      const video = this.performerVideos.find((video) => video.videoId === id);
      video.likes -= 1;
      video.liked = false;
    });
  };

  @action getPlayUrl = (id) => {
    MyShopService.getPlayUrl(id)
      .then((response) => (this.playUrl = response.accessUrl))
      .catch((err) => logger.error(err));
  };

  @action hasAccess = (item) => {
    if (
      item.isInLibrary ||
      this.username === item.username ||
      (item.isViewerInFanclub && item.fanClubCost === 0) ||
      item.cost === 0
    ) {
      return true;
    }

    return false;
  };

  @action addToLibrary = (id) => {
    this.videoActionState = APIStates.PENDING;

    MyShopService.addToLibrary(id)
      .then(() => {
        this.videoActionState = APIStates.LOADED;
        this.performerVideos = this.performerVideos.map((video) => {
          if (video.videoId === id) {
            return { ...video, isInLibrary: true };
          }

          return video;
        });
        MyShopService.getUpdatedBalance();
      })
      .catch((err) => {
        logger.error(err);
        this.videoActionState = APIStates.ERROR;
      });
  };

  @action buyVideo = (id) => {
    this.videoActionState = APIStates.PENDING;
    MyShopService.buyVideo(id)
      .then((response) => {
        this.videoPurchased = true;
        this.videoActionState = APIStates.LOADED;
        const video = this.performerVideos.find((video) => video.videoId === id);
        video.purchased = true;
        video.isInLibrary = true;
        video.purchaseSuccess = true;
        this.playUrl = response.accessUrl;
        this.allCount -= 1;
        this.allCost = video.isViewerInFanclub ? this.allCost - video.fanClubCost : this.allCost - video.cost;
        MyShopService.getUpdatedBalance();
      })
      .catch((err) => {
        logger.error(err);
        this.videoActionState = APIStates.ERROR;
      });
  };

  @computed get fanclubVideos() {
    return (
      this.performerVideos &&
      this.performerVideos.filter(
        (video) =>
          video.fanClubCost > 0 ||
          video.fanClubCost !== video.cost ||
          (video.discountActive && video.discountFanclubCost > 0)
      )
    );
  }

  @computed get hasFanclubVideos() {
    return this.performerVideos;
  }

  @computed get performerVideosLoading() {
    return this.performerVideosState === APIStates.PENDING;
  }
}
export default new MyShopStore();
